<template>
  <ChartLayout :title="title" :palette="palette" units="%">
    <DataGetter
      :url="apiRoute"
      :params="{
        startYear: 2000,
        allYears: true,
        countryISO,
        category:
          category === 'Clean Energy'
            ? 'Clean Energy'
            : [
                'Upstream',
                'Processing downstream',
                'Transmission distribution',
              ],
        topic: 'Patents',
        indicator: 'Detail',
      }"
      v-slot="{ data }"
      lazy
    >
      <DataSlicer
        :data="data"
        x-axis-dimension="year"
        :y-axis-dimension="yAxisDimension"
        value-dimension="value"
        :data-formatter="category === 'Clean Energy' ? null : mergeData"
        v-slot="{ slicedData }"
      >
        <Chart
          :options="{
            ...chartOptions,
            series: [...slicedData]
              .sort(
                seriesOrder
                  ? (a, b) =>
                      seriesOrder.indexOf(a.name) - seriesOrder.indexOf(b.name)
                  : (a, b) => (a.name > b.name ? 1 : -1)
              )
              .map((series, i) => ({
                ...series,
                colorIndex:
                  (seriesOrder ? seriesOrder.indexOf(series.name) : i) % 20,
              })),
          }"
        />
      </DataSlicer>
    </DataGetter>
    <template #notes>
      The datapoints for 2022 and 2023 are considered provisional due to the time lag in filing applications in the PATSTAT database.
      </template>
  </ChartLayout>
</template>

<script>
import { Chart } from "highcharts-vue";
import ChartOptions, {
  ChartLayout,
} from "@international-energy-agency/vue-ui/highcharts";
import { DataGetter, DataSlicer } from "@international-energy-agency/vue-ui";
export default {
  props: {
    title: {
      type: String,
      required: false,
    },
    apiRoute: {
      type: String,
      default: "https://api.iea.org/h2020",
    },
    category: {
      type: String,
      required: true,
    },
    countryISO: {
      type: String,
      required: true,
    },
    seriesOrder: {
      type: Array,
      default: null,
    },
    palette: {
      type: String,
      default: "tints",
    },
  },
  components: {
    Chart,
    ChartLayout,
    DataGetter,
    DataSlicer,
  },
  data() {
    return {
      chartOptions: ChartOptions.buildOptions(
        {
          chart: {
            height: 600,
          },
          xAxis: {
            min: 2000,
            showFirstLabel: true,
            showLastLabel: true
          },
          yAxis: {
            max: 100.5,
            endOnTick: false,
            reversedStacks: true,
            plotLines: [
              {
                value: 0,
                className: "highcharts-zero-axis",
              },
              {
                value: 100,
                className: "highcharts-zero-axis",
              },
            ],
          },
          tooltip: {
            valueDecimals: 0,
            pointFormat:
              "<span class='highcharts-color-{point.series.colorIndex}'>●</span> {point.series.name} <b>{point.percentage:.1f}%</b><br/>",
            shared: true,
          },
          plotOptions: {
            column: {
              groupPadding: 0,
              stacking: "percent",
              connectNulls: true,
              label: {
                enabled: true,
              },
            },
          },
          legend: {
            align: "right",
            layout: "proximate",
          },
        },
        "column"
      ),
    };
  },
  computed: {
    yAxisDimension() {
      return this.category === "Clean Energy" ? "techSector" : "category";
    },
  },
  methods: {
    mergeData(data) {
      return data.reduce((merged, row) => {
        const existing = merged.find(
          (mr) => mr.category === row.category && mr.year === row.year
        );
        if (existing) {
          existing.value += row.value;
        } else {
          merged.push({
            category: row.category,
            year: row.year,
            value: row.value,
          });
        }
        return merged;
      }, []);
    },
  },
};
</script>
